import { render, staticRenderFns } from "./SamlError.vue?vue&type=template&id=fe27b2a6&scoped=true"
import script from "./SamlError.vue?vue&type=script&lang=ts"
export * from "./SamlError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe27b2a6",
  null
  
)

export default component.exports